import { ClientSideStorageItems, ClientSideStorageService } from '../../react/services/client-side-storage.service';
import './information-banner.scss';

(function informationBanner() {
  const informationBanners = document.querySelectorAll('[data-component="information-banner"]') as NodeListOf<HTMLElement>;
  if (informationBanners && informationBanners.length > 0) {
    class InformationBanner {
      private bannersToClose: string[] = this.getBannersIdToHide();

      public init() {
        const informationBannerWrapper = document.getElementById('information-banner') as HTMLElement;
        informationBanners.forEach((element) => {
          const shouldHideBanner = this.getHideBanner(element.id);
          if (!shouldHideBanner) {
            this.show(element);
            this.show(informationBannerWrapper);
          }

          const closeButton = element.querySelector('.information-banner__item-btn-close') as HTMLButtonElement;
          if (closeButton) {
            closeButton.addEventListener('click', () => {
              const informationBannerId = `information-banner__item-${closeButton.getAttribute('data-information-banner-id')}`;
              if (informationBannerId) {
                const visibleBanners = informationBannerWrapper.querySelectorAll('[data-component="information-banner"]:not([hidden])');
                this.setCloseBanner(informationBannerId);
                this.hide(document.getElementById(informationBannerId) as HTMLElement);
                if (visibleBanners.length === 1) {
                  this.hide(informationBannerWrapper);
                }
              }
            });
          }
        });
      }

      private setCloseBanner(bannerId: string): void {
        this.bannersToClose.push(bannerId);
        ClientSideStorageService.setSessionStorage(ClientSideStorageItems.SessionStorage.HideInformationBanners, JSON.stringify(this.bannersToClose));
      }

      private getHideBanner(bannerId: string): boolean {
        return this.getBannersIdToHide().includes(bannerId);
      }

      private getBannersIdToHide(): string[] {
        return JSON.parse(ClientSideStorageService.getSessionStorage(ClientSideStorageItems.SessionStorage.HideInformationBanners) || '[]');
      }

      private hide(element: HTMLElement): void {
        const thisElement = element;
        thisElement.style.display = '';
        thisElement.setAttribute('hidden', 'hidden');

        const hideEvent = new Event('information-banners.hide');
        thisElement.dispatchEvent(hideEvent);
      }

      private show(element: HTMLElement): void {
        const thisElement = element;
        thisElement.style.display = '';
        thisElement.removeAttribute('hidden');
      }
    }
    const component = new InformationBanner();
    component.init();
  }
})();
